export class SkechersOrderAcceptanceRequest {
    id:number;
    poNumber: string;
    poStyle: string;
    exFactoryDate: string;
    deliveryDate: string;
    itemNo: string;
    color:string;
    price?:string;
}